"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServiceStatus = exports.loadConfiguration = exports.storageAdapter = exports.OPTIN_STATUS = exports.SCRIPT_NAME = exports.STORAGE_KEY = void 0;

var _storage = require("./storage");

var STORAGE_KEY = '__trackingOptInStatus';
exports.STORAGE_KEY = STORAGE_KEY;
var SCRIPT_NAME = '__toi';
exports.SCRIPT_NAME = SCRIPT_NAME;
var OPTIN_STATUS;
exports.OPTIN_STATUS = OPTIN_STATUS;

(function (OPTIN_STATUS) {
  /** Consent has not yet been given or has been reset */
  OPTIN_STATUS[OPTIN_STATUS["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  /** Consent has been granted */

  OPTIN_STATUS[OPTIN_STATUS["GRANTED"] = 1] = "GRANTED";
  /** Consent has been denied */

  OPTIN_STATUS[OPTIN_STATUS["DENIED"] = -1] = "DENIED";
})(OPTIN_STATUS || (exports.OPTIN_STATUS = OPTIN_STATUS = {}));
/** Wrapper to export a mutable object */


var storageAdapter = {
  instance: (0, _storage.localStorageAdapter)()
};
/** Retrieves the current configuration from the storage adapter */

exports.storageAdapter = storageAdapter;

var loadConfiguration = function loadConfiguration() {
  return JSON.parse(storageAdapter.instance.get(STORAGE_KEY) || '{}') || {};
};
/**
 * @param serviceId ID of a {@link TrackingOptInService}
 * @returns The consent status for this service or
 *      {@link OPTIN_STATUS.UNSPECIFIED} if not yet specified.
 */


exports.loadConfiguration = loadConfiguration;

var getServiceStatus = function getServiceStatus(serviceId) {
  return loadConfiguration()[serviceId] || OPTIN_STATUS.UNSPECIFIED;
};

exports.getServiceStatus = getServiceStatus;